import axios from 'axios'
import qs from 'qs'

class NaluriSuggest {
  static uri(path) {
    const ROOT_URL = process.env.NALURI_APP_NLP_ENDPOINT

    return ROOT_URL + path
  }

  static headers() {
    return {
      'content-type': 'application/json',
      'accept': 'application/json'
    }
  }

  static headersWithToken() {
    return Object.assign(NaluriSuggest.headers(), {
      'authorization': 'Bearer ' + process.env.NALURI_APP_NLP_TOKEN
    })
  }

  static request(resources, params, opts = {}) {
    let headers = NaluriSuggest.headersWithToken()
    let endpoint = NaluriSuggest.uri(resources)

    let options = Object.assign({}, {
      url: endpoint,
      headers,
    }, opts)

    return axios(endpoint, options)
      .then(NaluriSuggest.handleResponse)
      .catch(e => { throw NaluriSuggest.handleError(e) })
  }

  static get(resources, params, opts = {}) {
    opts = Object.assign({}, opts, {
      method: 'GET', data: null
    })

    resources = (!params) ? resources : resources + '?' + qs.stringify(params)

    return NaluriSuggest.request(resources, null, opts)
  }

  static post(resources, params, opts = {}) {
    opts = Object.assign({}, opts, {
      data: NaluriSuggest.serialize(params),
      method: 'POST'
    })

    return NaluriSuggest.request(resources, params, opts)
  }

  static formidable(resource, request, opts = {}) {
    let headers = NaluriSuggest.headersWithToken()
    delete headers['content-type']
    delete headers['accept']

    opts = {
      headers: { ...headers, 'content-type': 'multipart/form-data' },
      method: opts.method,
      data: request,
    };

    return NaluriSuggest.request(resource, request, opts);
  }

  static put(resources, params, opts = {}) {
    opts = Object.assign({}, opts, {
      data: NaluriSuggest.serialize(params),
      method: 'PUT'
    })

    return NaluriSuggest.request(resources, params, opts)
  }

  static delete(resources, params, opts = {}) {
    opts = Object.assign({}, opts, {
      data: NaluriSuggest.serialize(params),
      method: 'DELETE'
    })

    return NaluriSuggest.request(resources, params, opts)
  }

  static serialize(params) {
    return JSON.stringify(params)
  }

  static handleResponse(response) {
    const { status, data } = response

    if (status < 200 || status > 300) {
      throw this.handleError(response)
    }
    return data
  }

  static handleError(error) {
    const errs = error && error.response ? error.response.data : error
    console.warn('[ERROR]', errs)
    return errs
  }
}

export default NaluriSuggest



// WEBPACK FOOTER //
// ./src/common/api/naluriSuggest.js